// IE 2026 10 12 / ODOO-335099 (заказ Андрея через dm #72941, RP1; образец — MRV_001 «Введення плану активностей», 4 закреплённые колонки, 5 уровней дерева):
// заголовок строки-группы резался границей закреплённых колонок. При горизонтальной прокрутке 0 текст продолжается поверх пустых незакреплённых ячеек той же
// строки справа (до первой непустой); при прокрутке — прежняя обрезка по закреплённой области. Чистая часть — здесь; разметка ячейки и атрибут хоста — AttrGrid.vue.

// Ширина «перетекания» за границей закреплённых колонок, px: колонки начиная с frozen; колонки до c2 (конец объединения ячейки группы) входят без проверки —
// объединение уже из пустых; дальше — пока ячейка пуста (вместе со всем своим объединением span(j) — merge «назад» может тянуть значение влево), не дальше maxExt.
// n — число колонок; width(j) — ширина видимой колонки (скрытая = 0); empty(j) — пусто ли значение; span(j) — последняя колонка объединения ячейки j (или j).
export function gho_extent({ n, frozen, c2, width, empty, span, maxExt }) {
    let ext = 0
    const lim = Number.isFinite(maxExt) && maxExt > 0 ? maxExt : Infinity
    let j = frozen
    while (j < n && ext < lim) {
        if (j <= c2) { ext += width(j) || 0; j++; continue }
        let j2 = span ? span(j) : j
        if (!Number.isFinite(j2) || j2 < j) j2 = j
        if (j2 >= n) j2 = n - 1
        let ok = true
        for (let k = j; k <= j2; k++) if (!empty(k)) { ok = false; break }
        if (!ok) break
        for (let k = j; k <= j2; k++) ext += width(k) || 0
        j = j2 + 1
    }
    return Math.max(0, Math.min(ext, lim))
}

// Правая граница видимого текста относительно ячейки: inset справа для clip-path (отрицательное — за правым краем ячейки).
// cellW — ширина элемента ячейки, cellLeft — его левый край в координатах панели, frozenW — ширина закреплённой области, ext — перетекание.
export function gho_clipRight(cellW, cellLeft, frozenW, ext) {
    const limitW = Math.max(0, (frozenW || 0) - (cellLeft || 0)) + Math.max(0, ext || 0)
    return Math.round((cellW || 0) - limitW)
}
